import React, { useState, useEffect } from "react";
import "../../../styles/Part5DirectReading.css";
import { pattern7Data } from "../../../data/sentencePatterns/pattern7";
import { pattern8Data } from "../../../data/sentencePatterns/pattern8";
import { pattern9Data } from "../../../data/sentencePatterns/pattern9";
import { pattern10Data } from "../../../data/sentencePatterns/pattern10";
import { pattern11Data } from "../../../data/sentencePatterns/pattern11";
import { pattern12Data } from "../../../data/sentencePatterns/pattern12";
import { pattern14Data } from "../../../data/sentencePatterns/pattern14";
import { pattern15Data } from "../../../data/sentencePatterns/pattern15";
import { pattern16Data } from "../../../data/sentencePatterns/pattern16";
import { pattern17Data } from "../../../data/sentencePatterns/pattern17";
import { pattern18Data } from "../../../data/sentencePatterns/pattern18";
import { pattern19Data } from "../../../data/sentencePatterns/pattern19";
import { pattern20Data } from "../../../data/sentencePatterns/pattern20";
import { pattern21Data } from "../../../data/sentencePatterns/pattern21";
import { pattern22Data } from "../../../data/sentencePatterns/pattern22";
import { pattern23Data } from "../../../data/sentencePatterns/pattern23";
import { pattern24Data } from "../../../data/sentencePatterns/pattern24";
import { pattern25Data } from "../../../data/sentencePatterns/pattern25";
import { db } from "../../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useAuth } from "../../../contexts/AuthContext";

const BlankTrainingExercise = ({ onBack, patternId }) => {
  const [revealedEnglishChunks, setRevealedEnglishChunks] = useState([]);
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);
  const { currentUser } = useAuth();
  const [showCompletionModal, setShowCompletionModal] = useState(false);

  const id = Number(patternId);

  // 데이터 선택 로직
  let sentences;
  let title;

  // patternId에 따라 데이터 선택
  const patternData = {
    7: { data: pattern7Data, title: "시제 (Tense)" },
    8: { data: pattern8Data, title: "가정법 및 도치" },
    9: { data: pattern9Data, title: "전치사, 접속부사, 접속사" },
    10: { data: pattern10Data, title: "동명사, to부정사" },
    11: { data: pattern11Data, title: "분사구문" },
    12: { data: pattern12Data, title: "관계사 및 수식하는 문장" },
    14: { data: pattern14Data, title: "접속사, 부사절 접속사" },
    15: { data: pattern15Data, title: "지시대명사, 부정대명사" },
    16: { data: pattern16Data, title: "병렬구조" },
    17: { data: pattern17Data, title: "관계사 관련" },
    18: { data: pattern18Data, title: "시제" },
    19: { data: pattern19Data, title: "수동태/능동태 (Active/Passive Voice)" },
    20: { data: pattern20Data, title: "수일치 (Subject-Verb Agreement)" },
    21: { data: pattern21Data, title: "한정사/대명사 (Determiners/Pronouns)" },
    22: {
      data: pattern22Data,
      title: "비교급/최상급 (Comparative/Superlative)",
    },
    23: { data: pattern23Data, title: "전치사 (Prepositions)" },
    24: {
      data: pattern24Data,
      title: "접속사/접속부사 (Conjunctions/Conjunctive Adverbs)",
    },
    25: {
      data: pattern25Data,
      title: "꾸미거나 보충하는 요소들 (Modifiers & Complements)",
    },
  };

  sentences = patternData[id]?.data || [];
  title = patternData[id]?.title || "";

  const currentSentence = sentences[currentSentenceIndex];

  const handleEnglishChunkClick = (index) => {
    if (revealedEnglishChunks.includes(index)) {
      setRevealedEnglishChunks(
        revealedEnglishChunks.filter((i) => i !== index)
      );
    } else {
      setRevealedEnglishChunks([...revealedEnglishChunks, index]);
    }
  };

  const handleNext = () => {
    if (currentSentenceIndex < sentences.length - 1) {
      setCurrentSentenceIndex(currentSentenceIndex + 1);
      setRevealedEnglishChunks([]);
    }
  };

  const handlePrev = () => {
    if (currentSentenceIndex > 0) {
      setCurrentSentenceIndex(currentSentenceIndex - 1);
      setRevealedEnglishChunks([]);
    }
  };

  const markCategoryAsCompleted = async () => {
    if (!currentUser) return;

    try {
      const userDocRef = doc(db, "users", currentUser.uid);
      await updateDoc(userDocRef, {
        [`part5.blankTraining.${patternId}.completed`]: true,
      });
      setShowCompletionModal(true);
    } catch (error) {
      console.error("완료 상태 저장 중 오류:", error);
    }
  };

  const handleConfirmCompletion = () => {
    setShowCompletionModal(false);
    onBack();
  };

  const handleContinueLearning = () => {
    setShowCompletionModal(false);
  };

  const isLastSentence = currentSentenceIndex === sentences.length - 1;

  return (
    <div className="direct-reading-container">
      <button className="back-button" onClick={onBack}>
        ← 뒤로가기
      </button>

      <h2>{title} 빈칸 훈련</h2>

      <div className="sentence-container">
        {/* 한글 문장 먼저 표시 */}
        <div className="korean-chunks">
          {currentSentence.koreanChunks.map((chunk, index) => (
            <span key={index} className="chunk revealed">
              {chunk}
            </span>
          ))}
        </div>

        {/* 영어 문장은 클릭해서 확인 */}
        <div className="english-chunks">
          {currentSentence.englishChunks.map((chunk, index) => (
            <span
              key={index}
              className={`chunk ${
                revealedEnglishChunks.includes(index) ? "revealed" : "hidden"
              }`}
              onClick={() => handleEnglishChunkClick(index)}
            >
              {revealedEnglishChunks.includes(index) ? chunk : "___"}
            </span>
          ))}
        </div>

        {revealedEnglishChunks.length ===
          currentSentence.englishChunks.length && (
          <>
            <div className="full-sentence">{currentSentence.fullEnglish}</div>
            {currentSentence.additionalExplanation && (
              <div className="additional-explanation">
                <h4>추가 설명:</h4>
                <p>{currentSentence.additionalExplanation}</p>
              </div>
            )}
          </>
        )}
      </div>

      <div className="navigation-buttons">
        <button onClick={handlePrev} disabled={currentSentenceIndex === 0}>
          이전
        </button>
        <span>
          {currentSentenceIndex + 1} / {sentences.length}
        </span>
        {isLastSentence ? (
          <button onClick={markCategoryAsCompleted} className="complete-button">
            학습 완료
          </button>
        ) : (
          <button
            onClick={handleNext}
            disabled={currentSentenceIndex === sentences.length - 1}
          >
            다음
          </button>
        )}
      </div>

      {showCompletionModal && (
        <div className="completion-modal">
          <div className="modal-content">
            <h3>학습 완료!</h3>
            <p>학습이 성공적으로 완료되었습니다.</p>
            <p>카테고리로 돌아가시겠습니까?</p>
            <div className="modal-buttons">
              <button onClick={handleConfirmCompletion}>카테고리로 이동</button>
              <button onClick={handleContinueLearning}>계속 학습하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlankTrainingExercise;
